import React from 'react'
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CloudSyncIcon from '@mui/icons-material/CloudSync';

const Technology = () => {
    const [expanded, setExpanded] = React.useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };
    return (
        <>
            <div style={{ width: '80%', display: 'flex', margin:'auto', marginTop:'2rem', marginBottom:'1rem'}}>
                <CloudSyncIcon style={{ color: '#10609e' }}/>
                <p style={{ width: '80%', marginTop: '3px', marginLeft:'1rem', fontWeight:'bold', color:'#10609e' }}>Technology troubleshooting:</p><br />
            </div>
            <Accordion className='accordian_members' expanded={expanded === 'panel16'} onChange={handleChange('panel16')} style={{ width: '80%', marginLeft: 'auto', marginRight: 'auto' }}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel4bh-content"
                    id="panel4bh-header"
                >
                    <Typography className='typo_heading' sx={{ width: '85%', flexShrink: 0 }}>What can I do if the data in REDCap is not syncing?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography >
                        Please take a screenshot of the error message you are receiving and forward this screenshot to the UOW Coordinating Centre <a href='mailto:sunrise-uowcentre@uow.edu.au'> sunrise-uowcentre@uow.edu.au</a> for further advice.
                    </Typography>
                </AccordionDetails>
            </Accordion>
            <Accordion className='accordian_members' expanded={expanded === 'panel17'} onChange={handleChange('panel17')} style={{ width: '80%', marginLeft: 'auto', marginRight: 'auto' }}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel4bh-content"
                    id="panel4bh-header"
                >
                    <Typography className='typo_heading' sx={{ width: '85%', flexShrink: 0 }}>What can I do it the data in the EYToolbox is not syncing?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography >
                        <ul style={{ listStyleType: 'none' }}>
                            <li>If the data in the EYToolbox is not syncing, it might be due to the data getting ‘stuck’ on the iPad. You can try the following steps to resolve this issue:</li>
                            <ol style={{ marginLeft: '2rem' }}>
                                <li>Connect the iPads to the internet.</li>
                                <li>Open each EYToolbox app and play through them.</li>
                                <li>Label this data as "Test" in the child ID section to differentiate it from actual participant data.</li>
                                <li>Once you have completed play each iPad game, let them sit on the end page for approximately 1 minute. This helps push the data through to the database.</li>
                                <li>If the data still doesn't sync after following these steps, please contact the UOW Coordinating Centre at <a href='mailto:sunrise-uowcentre@uow.edu.au'> sunrise-uowcentre@uow.edu.au</a> for
                                    troubleshooting advice. They will be able to provide further guidance and support to resolve any syncing issues with the EYToolbox data.</li>
                            </ol>
                        </ul>
                    </Typography>
                </AccordionDetails>
            </Accordion>


            <Accordion className='accordian_members' expanded={expanded === 'panel20'} onChange={handleChange('panel20')} style={{ width: '80%', marginLeft: 'auto', marginRight: 'auto' }}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel4bh-content"
                    id="panel4bh-header"
                >
                    <Typography className='typo_heading' sx={{ width: '85%', flexShrink: 0 }}>What happens if I enter an incorrect Child ID in EYToolbox games or as the Record ID in REDCap?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography >
                        Please contact the SUNRISE Coordinating Centre <a href='mailto:sunrise-uowcentre@uow.edu.au'> sunrise-uowcentre@uow.edu.au</a> with the details and date/time of testing, so we can correct the error as soon as
                        possible. Please make note of this error in the ‘comment’ section in REDCap for the incorrectly labelled assessment.
                    </Typography>
                </AccordionDetails>
            </Accordion>
        </>
    )
}

export default Technology
